import { render } from "./HeaderUniversiteitgent.vue?vue&type=template&id=70b3600d&scoped=true"
import script from "./HeaderUniversiteitgent.vue?vue&type=script&lang=js"
export * from "./HeaderUniversiteitgent.vue?vue&type=script&lang=js"

import "./HeaderUniversiteitgent.vue?vue&type=style&index=0&id=70b3600d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b3600d"]])

export default __exports__